import type { PieChartComponentSpec } from "../Processing/types";
import type { DuplicationHandler } from "../widgetContract";

export const pieDuplicate: DuplicationHandler<PieChartComponentSpec> = (spec) => {
  for (const s of spec.series) {
    s.queryId = crypto.randomUUID();
  }
};
